import gql from "graphql-tag";

export const brandDetailsFragment = gql`
  fragment BrandDetailsFragment on Brand {
    id
    name
    legalName
    tinNo
    code
    mobileNo
    vendorId
  }
`;
